export const copyToClipboard = async (text, setToastMessage, expiresIn) => {
    try {
      await navigator.clipboard.writeText(text);
      setToastMessage(`Link copied! Expires in ${expiresIn} min`);
    } catch {
      setToastMessage("Copy failed — please copy manually.");
    }
  };